import axios from 'axios'

export default {
  getAll: async sitePath => {
    const url = `${sitePath}/user/`
    // site is the last path of sitePath
    // /1/2/3 --> 3
    const site = sitePath.split('/').slice(-1)[0]
    const params = { site }
    const response = await axios.get(url, { params })

    return response.data
  },

  delete: async (sitePath, id) => {
    const url = `${sitePath}/user/${id}/`
    const response = await axios.delete(url)

    return response.data
  },

  get: async (sitePath, id) => {
    const url = `${sitePath}/user/${id}/`
    const response = await axios.get(url)

    return response.data
  },

  post: async (sitePath, data) => {
    const url = `${sitePath}/user/`
    const response = await axios.post(url, data)

    return response.data
  },

  put: async (sitePath, id, data) => {
    const url = `${sitePath}/user/${id}/`
    const response = await axios.put(url, data)

    return response.data
  },

  postUser: async (sitePath, formData) => {
    const url = `${sitePath}/user/`
    let response = await axios.post(
        url,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
    return response.data
  },

  putUser: async (sitePath, id, formData) => {
    const url = `${sitePath}/user/${id}/`
    let response = await axios.put(
        url,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
    return response.data
  },
}
